import type { AppError } from '@/types'
import { AlertIcon } from '@/components/icons'
import { Button } from './Button'
import './ErrorState.css'

export type ErrorStateProps = {
  title?: string
  error?: AppError
  onRetry?: () => void
}

/**
 * Honest async error surface (contract §1, §9): shows the AppError
 * userMessage and offers retry when the error is retryable or a handler
 * is supplied.
 */
export function ErrorState({ title = 'Er ging iets mis', error, onRetry }: ErrorStateProps) {
  const showRetry = Boolean(onRetry) && (error ? error.retryable : true)
  return (
    <div className="ui-error-state" role="alert">
      <span className="ui-error-state__icon" aria-hidden="true">
        <AlertIcon size={28} />
      </span>
      <h2 className="ui-error-state__title">{title}</h2>
      {error && <p className="ui-error-state__body">{error.userMessage}</p>}
      {showRetry && onRetry && (
        <div className="ui-error-state__action">
          <Button variant="secondary" onClick={onRetry}>
            Opnieuw proberen
          </Button>
        </div>
      )}
    </div>
  )
}
